// Crash reporting first: `import` statements are hoisted and evaluated in
// source order, so this is what puts the handler in place before './App' and
// the module graph under it are evaluated. See src/sentry.ts.
import { ErrorBoundary } from './sentry';

import React from 'react';
import { createRoot } from 'react-dom/client';

import { App } from './App';
import './theme/tokens.css';

createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <ErrorBoundary
      fallback={
        <div className="flex h-full flex-col items-center justify-center p-8 text-center">
          <h1 className="font-display text-[34px] font-semibold text-ink">Something went wrong.</h1>
          <p className="mt-2 max-w-[40ch] text-[15px] leading-relaxed text-ink-2">Reload the page — your changes are saved locally and will sync.</p>
          <button type="button" onClick={() => window.location.reload()} className="frog-gradient mt-6 rounded-full px-5 py-2.5 text-sm font-semibold text-white">Reload</button>
        </div>
      }
    >
      <App />
    </ErrorBoundary>
  </React.StrictMode>,
);
